module.exports = __webpack_public_path__ + "media/images/early-music-5-33bb00d433f12207e71511a0a040e22b.jpg";